/**
 * @generated SignedSource<<cd43b682fea051705828b8cc961a9b7d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpRespFeaturedItemsGridLazy_viewer$data = {
  readonly sponsoredItems: {
    readonly " $fragmentSpreads": FragmentRefs<"PdpRespFeaturedItemsGrid_sponsoredItems">;
  } | null;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespFeaturedItemsGrid_viewer">;
  readonly " $fragmentType": "PdpRespFeaturedItemsGridLazy_viewer";
};
export type PdpRespFeaturedItemsGridLazy_viewer$key = {
  readonly " $data"?: PdpRespFeaturedItemsGridLazy_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespFeaturedItemsGridLazy_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "guestId"
    },
    {
      "kind": "RootArgument",
      "name": "isTrade"
    },
    {
      "kind": "RootArgument",
      "name": "itemId"
    },
    {
      "kind": "RootArgument",
      "name": "maxSponsoredItems"
    },
    {
      "kind": "RootArgument",
      "name": "minSponsoredItemsSteps"
    },
    {
      "kind": "RootArgument",
      "name": "numOfSponsoredItems"
    },
    {
      "kind": "RootArgument",
      "name": "priceBookName"
    },
    {
      "kind": "RootArgument",
      "name": "userCountryCode"
    },
    {
      "kind": "RootArgument",
      "name": "userId"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespFeaturedItemsGridLazy_viewer",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespFeaturedItemsGrid_viewer"
    },
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "guestId",
          "variableName": "guestId"
        },
        {
          "kind": "Variable",
          "name": "isTrade",
          "variableName": "isTrade"
        },
        {
          "kind": "Variable",
          "name": "itemId",
          "variableName": "itemId"
        },
        {
          "kind": "Variable",
          "name": "maxItems",
          "variableName": "maxSponsoredItems"
        },
        {
          "kind": "Variable",
          "name": "minItemsSteps",
          "variableName": "minSponsoredItemsSteps"
        },
        {
          "kind": "Variable",
          "name": "pageSize",
          "variableName": "numOfSponsoredItems"
        },
        {
          "kind": "Variable",
          "name": "priceBookName",
          "variableName": "priceBookName"
        },
        {
          "kind": "Variable",
          "name": "userCountryCode",
          "variableName": "userCountryCode"
        },
        {
          "kind": "Variable",
          "name": "userId",
          "variableName": "userId"
        }
      ],
      "concreteType": "SponsoredItems",
      "kind": "LinkedField",
      "name": "sponsoredItems",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "PdpRespFeaturedItemsGrid_sponsoredItems"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "e67dce8938a4f978d369d998a6765394";

export default node;
